import { apiSlice } from '../apiSlice';
import { SuccessResponse, Paginated } from '../DTO/common.interface';
import {
	WishFilter,
	GameBlessingCardSeriesDTO,
	GameBlessingCardSeriesDTORequest,
	GameBlessingCardTreasureDTO,
	PublishDTO,
	TreasureFilter,
} from '../DTO/treasury/wish.interface';

export const wishApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getWishPage: builder.query<
			SuccessResponse<Paginated<GameBlessingCardSeriesDTO>>,
			WishFilter
		>({
			query: (body) => ({
				url: `/web/game/blessing-card/series/page`,
				method: 'POST',
				body,
			}),
			providesTags: ['WishList'],
		}),
		getWishSortList: builder.query<
			SuccessResponse<GameBlessingCardSeriesDTO[]>,
			null
		>({
			query: () => ({
				url: `/web/game/blessing-card/series/sort`,
				method: 'GET',
			}),
		}),
		sortWish: builder.mutation<SuccessResponse<any>, string[]>({
			query: (body) => ({
				url: `/web/game/blessing-card/series/sort`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['WishList'],
		}),
		createWish: builder.mutation<
			SuccessResponse<any>,
			GameBlessingCardSeriesDTORequest
		>({
			query: (body) => ({
				url: `/web/game/blessing-card`,
				method: 'POST',
				body,
			}),
		}),
		updateWish: builder.mutation<
			SuccessResponse<any>,
			GameBlessingCardSeriesDTORequest
		>({
			query: (body) => ({
				url: `/web/game/blessing-card/series/${body.id}`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['WishDetail'],
		}),
		setWishStatus: builder.mutation<
			SuccessResponse<any>,
			{ publishList: PublishDTO[] }
		>({
			query: (body) => ({
				url: `/web/game/blessing-card/series/published`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['WishList', 'WishDetail'],
		}),
		getWishDetail: builder.query<
			SuccessResponse<GameBlessingCardSeriesDTO>,
			string
		>({
			query: (id) => ({
				url: `/web/game/blessing-card/series/${id}`,
				method: 'GET',
			}),
			providesTags: ['WishDetail'],
		}),
		getWishTreasurePage: builder.query<
			SuccessResponse<Paginated<GameBlessingCardTreasureDTO>>,
			TreasureFilter
		>({
			query: (body) => ({
				url: `/web/game/blessing-card/series/${body.seriesId}/page`,
				method: 'POST',
				body,
			}),
			providesTags: ['WishTreasureList'],
		}),
		getWishTreasureSortList: builder.query<
			SuccessResponse<GameBlessingCardTreasureDTO[]>,
			string
		>({
			query: (id) => ({
				url: `/web/game/blessing-card/series/${id}/sort`,
				method: 'GET',
			}),
		}),
		sortWishTreasure: builder.mutation<SuccessResponse<any>, string[]>({
			query: (body) => ({
				url: `/web/game/blessing-card/treasure/sort`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['WishTreasureList'],
		}),
		setWishTreasureStatus: builder.mutation<
			SuccessResponse<any>,
			{ publishList: PublishDTO[]; id: string }
		>({
			query: (body) => ({
				url: `/web/game/blessing-card/treasure/published`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['WishTreasureList', 'WishTreasureDetail'],
		}),
		deleteWish: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/game/blessing-card/series/${id}`,
				method: 'DELETE',
			}),
		}),
		getWishTreasureDetail: builder.query<
			SuccessResponse<GameBlessingCardTreasureDTO>,
			string
		>({
			query: (id) => ({
				url: `/web/game/blessing-card/treasure/${id}`,
				method: 'GET',
			}),
			providesTags: ['WishTreasureDetail'],
		}),
		updateWishTreasureDetail: builder.mutation<
			SuccessResponse<any>,
			GameBlessingCardTreasureDTO
		>({
			query: (body) => ({
				url: `/web/game/blessing-card/treasure/${body.id}`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['WishTreasureDetail'],
		}),
		createWishTreasure: builder.mutation<
			SuccessResponse<any>,
			GameBlessingCardTreasureDTO
		>({
			query: (body) => ({
				url: `/web/game/blessing-card/series/${body.wishId}`,
				method: 'POST',
				body,
			}),
		}),
		deleteWishTreasure: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/game/blessing-card/treasure/${id}`,
				method: 'DELETE',
			}),
		}),
	}),
});

export const {
	useGetWishPageQuery,
	useGetWishSortListQuery,
	useSortWishMutation,
	useCreateWishMutation,
	useUpdateWishMutation,
	useSetWishStatusMutation,
	useGetWishDetailQuery,
	useGetWishTreasurePageQuery,
	useGetWishTreasureSortListQuery,
	useSortWishTreasureMutation,
	useSetWishTreasureStatusMutation,
	useDeleteWishMutation,
	useGetWishTreasureDetailQuery,
	useUpdateWishTreasureDetailMutation,
	useCreateWishTreasureMutation,
	useDeleteWishTreasureMutation,
} = wishApiSlice;
